package org.multiplatform.kotfolio.util

import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlin.time.Duration.Companion.milliseconds

@Composable
fun observerViewPortEntered(
    sectionId: String,
    distanceFromTop: Double = 0.0, // Kept for signature compatibility
    onViewPortEntered: () -> Unit,
) {
    LaunchedEffect(sectionId) {
        val element = document.getElementById(sectionId)
        if (element != null) {
            // Using dynamic access to the browser's IntersectionObserver
            // This bypasses strict type checking while maintaining Kotlin logic and capturing
            val observerConstructor = window.asDynamic().IntersectionObserver
            if (observerConstructor != null) {
                val options = js("({ threshold: 0.15 })")
                val observer = js("new IntersectionObserver(function(entries, obs) { entries.forEach(function(entry) { if (entry.isIntersecting) { onViewPortEntered(); obs.disconnect(); } }); }, options)")
                observer.observe(element)
            } else {
                // Fallback for browsers that don't support IntersectionObserver
                onViewPortEntered()
            }
        }
    }
}

suspend fun animateNumbers(
    number: Int,
    delay: Long = 10L,
    onUpdate: (Int) -> Unit,
) {
    (0..number).forEach {
        delay(delay.milliseconds)
        onUpdate(it)
    }
}
